"use strict";

var _objectWithoutProperties = require("/root/website/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonIconOnly = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _ButtonIconOnly = require("./components/ButtonIconOnly");

var _Loading = require("./components/Loading");

var _core = require("@emotion/core");

var ButtonIconOnly = function ButtonIconOnly(_ref) {
  var size = _ref.size,
      disabled = _ref.disabled,
      children = _ref.children,
      onClick = _ref.onClick,
      loading = _ref.loading,
      props = _objectWithoutProperties(_ref, ["size", "disabled", "children", "onClick", "loading"]);

  return (0, _core.jsx)(_ButtonIconOnly.StyledButtonIconOnly, (0, _extends2.default)({}, props, {
    size: size,
    disabled: disabled,
    "data-testid": "icon-button",
    onClick: onClick
  }), loading ? (0, _core.jsx)(_Loading.Loading, {
    size: size
  }) : children);
};

exports.ButtonIconOnly = ButtonIconOnly;
process.env.NODE_ENV !== "production" ? ButtonIconOnly.propTypes = {
  disabled: _propTypes.bool,
  size: (0, _propTypes.oneOf)(['medium', 'large']),
  children: _propTypes.element.isRequired,
  onClick: _propTypes.func,
  loading: _propTypes.bool
} : void 0;
ButtonIconOnly.defaultProps = {
  disabled: false,
  loading: false,
  size: 'medium',
  onClick: function onClick() {
    return null;
  }
};
ButtonIconOnly.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ButtonIconOnly",
  "props": {
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "loading": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "size": {
      "defaultValue": {
        "value": "'medium'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "element"
      },
      "required": true,
      "description": ""
    }
  }
};